import { useQuery } from '@tanstack/react-query';

import { useAuth } from '@/contexts/AuthContext';
import { createApiClient } from '@/shared/api/apiClient';

export interface UseUserAllocationGroupMembershipOptions {
  userId: string;
  organizationId: number;
  groupIds: number[];
  enabled?: boolean;
}

export function useUserAllocationGroupMembership({
  userId,
  organizationId,
  groupIds,
  enabled = true,
}: UseUserAllocationGroupMembershipOptions) {
  const { getAccessToken } = useAuth();

  return useQuery({
    queryKey: ['user-allocation-group-membership', organizationId, userId, groupIds],
    queryFn: async ({ signal }) => {
      if (!userId) {
        throw new Error('userId is required to check allocation group membership');
      }

      const client = createApiClient(getAccessToken, {
        cache: 'no-store',
        signal,
      });

      const { data, error } = await client.POST('/api/organizations/{organizationId}/users/{userId}/allocation-groups/check', {
        params: {
          path: { organizationId, userId },
        },
        body: { groupIds },
      });

      if (error) {
        throw error;
      }

      return data ?? [];
    },
    enabled: enabled && !!userId && groupIds.length > 0,
    staleTime: 30000,
  });
}
